import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Task} from "../../shared/models/task.model";
import {DayInformationService} from "../../services/day-information.service";
import {sortCategoriesAndTasks} from "../../core/utils/task.utils";
import {KeyValuePipe, NgOptimizedImage} from "@angular/common";
import {RouterLink} from "@angular/router";
import {MatCard, MatCardContent, MatCardTitle} from "@angular/material/card";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {LanguageService} from '../../services/language.service';

@Component({
    selector: 'app-task-list',
    imports: [
        KeyValuePipe,
        RouterLink,
        MatCard,
        MatCardTitle,
        MatCardContent,
        TranslatePipe,
        NgOptimizedImage
    ],
    standalone: true,
    templateUrl: './task-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./task-list.component.scss']
})
export class TaskListComponent implements OnInit, OnChanges {

    @Input() searchText = '';

    private _searchText = '';

    categories: Map<string, Task[]> = new Map();
    allTasks = new Array<Task>();

    constructor(
        private dayService: DayInformationService,
        private translate: TranslateService,
        public language: LanguageService
    ) {
    }

    ngOnInit(): void {
        this.fetchAllTasks();

        this.translate.onLangChange.subscribe(_ => {
            this.fetchAllTasks();
        })
    }

    ngOnChanges(changes: SimpleChanges): void {
        const searchTextChanged = changes['searchText'];
        if (!searchTextChanged) return;

        const next = (searchTextChanged.currentValue ?? '') as string;
        const prev = (searchTextChanged.previousValue ?? '') as string;

        // skip if value didn’t actually change
        if (next == prev) return;

        this._searchText = next;
        this.initTasks();
    }

    private fetchAllTasks() {
        this.dayService.getAllTasks().subscribe((tasks: Task[]) => {
            this.allTasks = tasks;
            this.initTasks();
        });
    }

    private initTasks() {
        const allCategories: string[] = [];
        const unsorted: Map<string, Task[]> = new Map();

        for (const task of this.allTasks) {
            const categoryId = task.category.name;
            if (!allCategories.includes(categoryId)) {
                allCategories.push(categoryId);
            }
        }

        for (const category of allCategories) {
            const tasksForCategory = this.allTasks.filter(task => task.category.name === category);

            const tasksFiltered = this.filterTasks(tasksForCategory);
            if (tasksFiltered.length > 0) {
                unsorted.set(category, tasksFiltered);
            }
        }

        this.categories = sortCategoriesAndTasks(unsorted);
    }


    private filterTasks(tasks: Task[]): Task[] {
        if (!this._searchText) return tasks;

        return tasks.filter(task => this.shouldShowTask(task));
    }

    private shouldShowTask(task: Task): boolean {
        const header = task.header;
        const description = task.description;

        const lowerCaseText = this._searchText.toLowerCase();

        return header.toLowerCase().includes(lowerCaseText) ||
            description.toLowerCase().includes(lowerCaseText);
    }

}
